/**
 * Distinguish a dead network from a dead session.
 *
 * The two used to collapse into one "signed out" path: a laptop that woke on
 * a plane looked identical to an expired refresh token, and the app threw the
 * user at the login screen with their library still sitting on disk. A failed
 * fetch, a DNS blip, or Tauri's native HTTP stack refusing the hop is not an
 * auth failure.
 */

export function isNetworkError(error: unknown): boolean {
  if (error == null) return false;

  if (typeof error === "object" && "status" in error) {
    const status = (error as { status?: unknown }).status;
    if (typeof status === "number" && status > 0) return false;
  }

  const message =
    error instanceof Error
      ? `${error.name} ${error.message}`
      : typeof error === "string"
        ? error
        : String(error);

  return /failed to fetch|load failed|networkerror|network request failed|error sending request|connection refused|connection reset|timed out|timeout|offline|could not connect|dns|internet connection|not allowed to load local resource|nsurlerror|econnrefused|enotfound|ehostunreach/i.test(
    message,
  );
}
